import { Colors } from "./Colors";

export const Styles = {
    MAIN_COLOR: Colors.primary,
    MAIN_COLOR_HOVERED: Colors.primaryShade2,
    MAIN_COLOR_DISABLED: Colors.primaryShade1,
};
